import {Component, Fragment, h} from 'preact';
import BlockItemToggle from '../common/BlockItemToggle';
import BlockItem from '../common/BlockItem';

class AccountDetails extends Component {

	constructor(props) {
		super(props);
		this.state = {
			dataBlock: null,
			details: props.details,
		};
	}

	componentDidMount() {

	}

	toggleDataBlock(method){
		let dataBlock = document.querySelector('.block-item[data-id="'+method+'"]');
		dataBlock.classList.toggle('open');
	}

	render(props, state, context) {
		const details = state.details;
		return (
			<div className="account-details">
				<div className="account-details__title">К оплате</div>
				<div className="account-details__body">
					{details.map(detailsItem => (
						<Fragment>
							{
								detailsItem.type == 'extended'
									? <BlockItemToggle item={detailsItem} toggleHandler={this.toggleDataBlock.bind(this)}/>
									: <BlockItem item={detailsItem}/>
							}
						</Fragment>
					))}
				</div>
			</div>
		)
	}
}

export default AccountDetails;
